import styled from 'styled-components/macro';
// styles for placeholder of component on author
export const CustomPlaceholderStyled = styled.div `
  font-family: adobe-clean, 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Ubuntu, 'Trebuchet MS', 'Lucida Grande', sans-serif;
  font-size: 14px;
  line-height: 46px;
  color: #6e6e6e;
  background-color: rgba(255, 255, 255, 0.75);
  text-align: center;

  &:hover {
    color: #1473e6;
  }
`;
